<template>
	<div :class="rootClass">
		<InputLabel class="peer empty:hidden" :error="!!error">
			<slot name="label" v-if="!error" />
			<template v-else>
				{{ error }}
			</template>
		</InputLabel>
		<div class="group relative mt-2 min-w-fit max-w-full peer-empty:mt-0">
			<div
				class="peer/left pointer-events-none absolute left-3 top-0 flex h-full items-center text-label-secondary *:w-5 empty:hidden peer-enabled/main:group-hover:text-label-primary"
			>
				<slot name="leftIcon" />
			</div>
			<div
				class="peer/right pointer-events-none absolute right-3 top-0 flex h-full items-center text-label-secondary *:w-5 empty:hidden peer-enabled/main:group-hover:text-label-primary"
			>
				<slot name="rightIcon" />
			</div>
			<Component
				class="peer/main h-10.5 w-full rounded-xl bg-fill-primary py-2.5 pl-10 pr-10 text-sm font-medium text-label-primary outline outline-1 -outline-offset-1 outline-separator-primary enabled:focus:outline-offset-0 enabled:focus:outline-pink enabled:focus:ring-4 enabled:focus:ring-pink/20 disabled:bg-fill-secondary disabled:text-label-secondary peer-empty/left:pl-4 peer-empty/right:pr-4 dark:!ring-0 dark:focus:bg-fill-tertiary"
				:class="{
					'!outline-lava': error,
					'shadow shadow-gray/2 enabled:hover:shadow enabled:hover:shadow-gray/6':
						!flat
				}"
				v-bind="$attrs"
				:is="is"
			>
				<slot name="value" />
			</Component>
		</div>
	</div>
</template>
<script setup lang="ts">
import InputLabel from './InputLabel.vue'
import type { Component } from 'vue'

defineProps<{
	rootClass?: string
	is: Component | string
	error?: string
	flat?: boolean
}>()

defineOptions({
	inheritAttrs: false
})
</script>
